import { useState } from "react";
import { Link } from "react-router-dom";
import { Route } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";

const STEPS = [
  ["Dispute received", "Your processor's webhook lands in AEGIS within seconds and appears under 'My active disputes'."],
  ["Evidence auto-collected", "Payment auth, device, logins, access and delivery records are already signed and hash-chained. The dispute page shows what's missing."],
  ["Review the AI draft", "MARI drafts a bank-ready letter from your evidence and the reason code. Edit it, simulate it, then Stage it for approval."],
  ["You approve & submit", "Only the workspace owner can approve. Nothing is ever submitted without you, and you get reminders before the bank deadline."],
];

export const FirstDisputeTour = ({ disputeId }) => {
  const [i, setI] = useState(0);
  return (
    <Dialog onOpenChange={() => setI(0)}>
      <DialogTrigger asChild>
        <button className="flex items-center gap-2 px-4 py-2.5 bg-brand text-black font-mono text-xs font-bold tracking-wider hover:shadow-[0_0_24px_var(--brand)] transition-shadow" data-testid="first-dispute-btn">
          <Route className="w-4 h-4" /> FIRST DISPUTE? START HERE
        </button>
      </DialogTrigger>
      <DialogContent className="bg-canvas border-white/15 max-w-lg" data-testid="first-dispute-dialog">
        <DialogHeader><DialogTitle className="font-mono">Your first dispute, step by step</DialogTitle></DialogHeader>
        <div className="flex gap-1">{STEPS.map((_, k) => <span key={k} className={`h-1 flex-1 ${k <= i ? "bg-brand" : "bg-white/10"}`} />)}</div>
        <div className="min-h-[110px]" data-testid="first-dispute-step">
          <p className="font-mono text-[10px] text-brand">STEP 0{i + 1} / 0{STEPS.length}</p>
          <p className="text-lg font-bold mt-1">{STEPS[i][0]}</p>
          <p className="text-sm text-white/65 mt-2">{STEPS[i][1]}</p>
        </div>
        <div className="flex justify-between">
          <button disabled={!i} onClick={() => setI(i - 1)} className="font-mono text-xs text-white/50 hover:text-white disabled:opacity-30" data-testid="first-dispute-back">← BACK</button>
          {i < STEPS.length - 1
            ? <button onClick={() => setI(i + 1)} className="font-mono text-xs text-brand" data-testid="first-dispute-next">NEXT →</button>
            : disputeId && <Link to={`/app/disputes/${disputeId}`} className="font-mono text-xs text-brand" data-testid="first-dispute-open">OPEN MY NEXT DISPUTE →</Link>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
